module.exports = __webpack_public_path__ + "static/media/AddEmailIcon.2be631c4.svg";